"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bus_http_1 = require("@comunica/bus-http");
const solid = require('solid-auth-client');
class ActorHttpSolidAuthFetch extends bus_http_1.ActorHttp {
    constructor(args) {
        super(args);
    }
    async test(action) {
        return { time: Infinity };
    }
    run(action) {
        return solid.fetch(action.input, action.init);
    }
}
exports.ActorHttpSolidAuthFetch = ActorHttpSolidAuthFetch;
//# sourceMappingURL=ActorHttpSolidAuthFetch.js.map